import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_UILink = _resolveComponent("UILink")!
  const _component_SharedAuthCard = _resolveComponent("SharedAuthCard")!
  const _component_SharedModal2fa = _resolveComponent("SharedModal2fa")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createVNode(_component_SharedAuthCard, {
      headerSvg: "fingerprint",
      headerTitle: "Вход в систему",
      footerTitle: "У вас еще нет учетной записи?"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_LoginForm, {
          loading: _ctx.isLoading,
          message: _ctx.message,
          login: _ctx.authLoginRequest.login,
          "onUpdate:login": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.authLoginRequest.login) = $event)),
          password: _ctx.authLoginRequest.password,
          "onUpdate:password": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.authLoginRequest.password) = $event)),
          isRemember: _ctx.authLoginRequest.remember,
          "onUpdate:isRemember": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.authLoginRequest.remember) = $event)),
          onLogin: _ctx.handleLogin,
          onGoogle: _ctx.handleGoogle
        }, null, 8, ["loading", "message", "login", "password", "isRemember", "onLogin", "onGoogle"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_UILink, {
          label: "Создать аккаунт",
          view: "main-outline",
          to: "/registration"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_SharedModal2fa, {
      isVisible: _ctx.show2faModal,
      requiresMail2fa: _ctx.requiresMail2fa,
      requiresGoogle2fa: _ctx.requiresGoogle2fa,
      email: _ctx.authLoginRequest.login,
      remember: _ctx.authLoginRequest.remember,
      onClose: _ctx.handle2faClose,
      onConfirm: _ctx.handle2faConfirm
    }, null, 8, ["isVisible", "requiresMail2fa", "requiresGoogle2fa", "email", "remember", "onClose", "onConfirm"])
  ], 2))
}